export const categories = [
  {
    id: 1,
    namePl: "Buty",
    nameEn: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
    description: "Odkryj najnowsze modele butów w naszych spreadsheetach",
  },
  {
    id: 2,
    namePl: "Bluzy i Swetry",
    nameEn: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    icon: "ri-t-shirt-line",
    description: "Stylowe bluzy i swetry w najlepszych cenach",
  },
  {
    id: 3,
    namePl: "T-Shirty",
    nameEn: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    icon: "ri-shirt-line",
    description: "Koszulki od topowych marek w jednym miejscu",
  },
  {
    id: 4,
    namePl: "Kurtki",
    nameEn: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    icon: "ri-cloud-windy-line",
    description: "Kurtki na każdą porę roku – przeglądaj teraz",
  },
  {
    id: 5,
    namePl: "Spodnie i Szorty",
    nameEn: "Pants/Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    icon: "ri-pantone-line",
    description: "Spodnie i szorty w spreadsheetzie Kakobuy",
  },
  {
    id: 6,
    namePl: "Nakrycia Głowy",
    nameEn: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    icon: "ri-customer-service-line",
    description: "Czapki, kapelusze i akcesoria na głowę",
  },
  {
    id: 7,
    namePl: "Zestawy",
    nameEn: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    icon: "ri-stack-line",
    description: "Kompletne zestawy ubrań – oszczędzaj czas i pieniądze",
  },
  {
    id: 8,
    namePl: "Bielizna",
    nameEn: "Underwear/Underpants",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    icon: "ri-heart-line",
    description: "Bielizna i podstawowe elementy garderoby",
  },
  {
    id: 9,
    namePl: "Koszulki Sportowe",
    nameEn: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    icon: "ri-basketball-line",
    description: "Koszulki sportowe i odzież treningowa",
  },
  {
    id: 10,
    namePl: "Akcesoria",
    nameEn: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    icon: "ri-glasses-line",
    description: "Akcesoria modowe – okulary, biżuteria i więcej",
  },
  {
    id: 11,
    namePl: "Torby",
    nameEn: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    icon: "ri-briefcase-line",
    description: "Torby, plecaki i walizki w jednym arkuszu",
  },
  {
    id: 12,
    namePl: "Paski",
    nameEn: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    icon: "ri-link",
    description: "Paski i dodatki do ubrań – sprawdź ofertę",
  },
  {
    id: 13,
    namePl: "Perfumy",
    nameEn: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    icon: "ri-drop-line",
    description: "Perfumy i zapachy w najlepszych cenach",
  },
  {
    id: 14,
    namePl: "Inne Produkty",
    nameEn: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    icon: "ri-more-line",
    description: "Wszystkie pozostałe produkty w jednym miejscu",
  },
];